import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref, watch } from 'vue'
import FilterUi from './FilterUi.vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'FilterController',
  props: {
    loading: {},
    value: {},
    receive: {},
    all: {},
    parameters: {},
    permanent: {},
    displayed: {},
    hideFiltersControls: {}
  },
  emits: ["input"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

function isEmpty(value: any) {
  return (
    value === null ||
    value === '' ||
    typeof value === 'undefined' ||
    (Array.isArray(value) && value.length === 0) ||
    (Object(value) === value && Object.keys(value).length === 0)
  )
}

function orderFilters(list: any[], order: any[]) {
  const map = list.reduce((acc, x) => {
    acc[x.id] = x
    return acc
  }, {})
  return order.filter((x) => !!map[x]).map((x) => map[x])
}



const props = __props

const emit = __emit

const prepared = ref({})

prepare(props.value?.filters)
watch(
  () => props.value,
  (val) =>{
    const { filters = {} } = val || {} 
    // ({ filters = {} } = {}, { filters: oldFilters } = {}: any) =>{
    // if (isShallowEqual(filters, oldFilters)) {
    //   return;
    // }

    prepare(filters);
    // filter()
  },
{immediate: true, deep: true},
)

if (props.receive) {
  props.receive(props.parameters)
}

const empty = computed(() => Object.values(prepared.value).every(isEmpty))
const filters = computed<Record<string, any>[]>(() => {
  return props.all && props.all.length && props.displayed
    ? orderFilters(props.all, props.displayed)
    : []
})

function prepare(newValue: any) {
  prepared.value = newValue
}
function handleInputFilter(newValue: any) {
  handleInput(newValue)
  filter()
}
function handleInput(newValue: any) {
  prepare(newValue)
  nextTick(() => {
    filter()
    
  })
}
function filtrate(newValue: any) {
  // prepared.value = newValue
  prepare(newValue)
  filter()
}
function filter() {
  emit('input', { filters: prepared.value })
}
function clear() {
  emit('input', { ...props.value, filters: {}, ...this.permanent })
  prepare({ filters: {}, ...this.permanent })
}


const __returned__ = { isEmpty, orderFilters, props, emit, prepared, empty, filters, prepare, handleInputFilter, handleInput, filtrate, filter, clear, computed, nextTick, ref, watch, FilterUi }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})